// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgJournal = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.25 6A.75.75 0 0 1 6 5.25h12a.75.75 0 0 1 0 1.5H6A.75.75 0 0 1 5.25 6M5.25 10A.75.75 0 0 1 6 9.25h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75M12.25 14a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75M12.25 18a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.75 2.75v18.5h18.5V2.75zm-1.5-.15c0-.746.604-1.35 1.35-1.35h18.8c.746 0 1.35.604 1.35 1.35v18.8a1.35 1.35 0 0 1-1.35 1.35H2.6a1.35 1.35 0 0 1-1.35-1.35z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.25 14a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75H6a.75.75 0 0 1-.75-.75zm1.5.75v2.5h1.5v-2.5z"
      clipRule="evenodd"
    />
  </svg>
);
export const JournalIcon = forwardRef(SvgJournal);
